export default __webpack_public_path__ + "static/media/olivia.65ad325b.png";